export default "__VITE_ASSET__DSKYHIq2__"